export enum Languages {
  lv = 'LV',
  en = 'EN',
}
